import 'rxjs/Rx';
import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonComponent, EventObject, EventService, LoggerService, StoreEventsEnum} from '../../hbs-services';
import {SwalComponent} from '@toverux/ngx-sweetalert2';

@Component({
    selector: 'swal-modal',
    moduleId: module.id,
    templateUrl: './modal.component.html'
})
export class ModalComponent extends CommonComponent implements OnInit, OnDestroy {

    // Note: all SwalComponent(s) fields must have 'modal_' prefix to be found in getComponentField()
    @ViewChild('deletePollResponses') private modal_deletePollResponses: SwalComponent;
    @ViewChild('pollHasResponses') private modal_pollHasResponses: SwalComponent;
    @ViewChild('togglePollAudience') private modal_togglePollAudience: SwalComponent;

    public confirmButtonColor = '#3085d6';
    public cancelButtonColor = '#d33';
    public command: EventObject;

    private currentSwalComponent;

    constructor(private eventService: EventService,
                private ref: ChangeDetectorRef,
                protected logger: LoggerService) {
        super(logger);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.attachEventServiceSubscription(this.eventService.subscribe(command => {
            switch (command.type) {
                case StoreEventsEnum.OPEN_MODAL:
                    this.logger.log('ModalComponent: OPEN_MODAL', command);
                    return this.openModal(command);
            }
            return null;
        }));
    }

    public onAction(... args) {
        if (this.currentSwalComponent) {
            this.currentSwalComponent.nativeSwal.close();
            if (this.command && this.command.payload && this.command.payload.action) {
                this.command.payload.action(args);
            }
        }
        this.reset();
        return false;
    }

    private openModal(command: EventObject) {
        this.command = command;
        this.currentSwalComponent = this.getComponentField(command.payload.id);

        if (this.currentSwalComponent) {
            this.ref.detectChanges();   // need to update <swal> components after assigning this.command
            this.currentSwalComponent.show().then((result) => {
                if (command.payload && command.payload.callback) {
                    command.payload.callback(result);
                }
                this.reset();
            });
        } else {
            this.logger.error('Unknown Swal id in command', command);
            this.reset();
        }
    }

    private reset() {
        this.currentSwalComponent = null;
        this.command = null;
    }

    private getComponentField(name: string) : SwalComponent {
        const value = name.startsWith('modal_') ? (this as any)[name] as SwalComponent : null;
        return value;
    }
}
